import endpoints from '../../config/endpoints.json'

const actions = {}

const mutations = {}

const state = {
    endpoints: Object.keys(endpoints).reduce((acc, endpoint) => {
      const baseUrl =
      process.env.NODE_ENV === 'production'
        ? 'https://cryptocheck.amlexa.com/~api'
        : 'https://cryptocheck.amlexa.com/~api'

      return {
        ...acc,
        [endpoint]: `${baseUrl}${endpoints[endpoint]}`,
      }
    }, {}),
}

const getters = {
  endpoints: (state) => state.endpoints,
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
